import { render } from "./BaseviewAllotUpdate.vue?vue&type=template&id=33fdda98"
import script from "./BaseviewAllotUpdate.vue?vue&type=script&lang=js"
export * from "./BaseviewAllotUpdate.vue?vue&type=script&lang=js"

import "./BaseviewAllotUpdate.vue?vue&type=style&index=0&id=33fdda98&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__